const dayDispArr = [
  '日', '月', '火', '水', '木', '金', '土'
]

function _dateStrToDate(str, isUTC) {
  // wrong arg
  if (!str) { return null }
  // parsable string (should always be this)
  if (str.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/)) {
    str = str.replace(/-/g, '').replace(/:/g, '')
    let dateArgs = [
      parseInt(str.substr(0, 4)),
      parseInt(str.substr(4, 2)) - 1,
      parseInt(str.substr(6, 2)),
      parseInt(str.substr(9, 2)),
      parseInt(str.substr(11, 2)),
      parseInt(str.substr(13, 2)),
    ]
    if (isUTC) {
      dateArgs = [Date.UTC(...dateArgs)]
    }
    return new Date(...dateArgs)
  }
  // fallback. do something nice.
  return new Date(str.replace(/ /g, 'T'))
}

export const dateStrToDate = str => {
  return _dateStrToDate(str, false)
}

export const dateStrToDateUTC = str => {
  return _dateStrToDate(str, true)
}

function ensureDate(dt, isUTC) {
  if (!dt) { return null }

  let ret = dt
  if (typeof dt === 'string') {
    ret = _dateStrToDate(dt, isUTC)
  }
  return ret
}

function _dtFormat(date, format, isUTC) {
  date = ensureDate(date, isUTC)
  if (!date) { return '' }
  const y = date.getFullYear()
  const mon = date.getMonth() + 1
  const d = date.getDate()
  const youbi = dayDispArr[date.getDay()]
  const h = date.getHours()
  const min = date.getMinutes()
  const s = date.getSeconds()
  return format
    .replace(/yyyy/g, y)
    .replace(/mm/g, ('0' + mon).slice(-2))
    .replace(/m/g, mon)
    .replace(/dd/g, ('0' + d).slice(-2))
    .replace(/d/g, d)
    .replace(/a/g, youbi)
    .replace(/HH/g, ('0' + h).slice(-2))
    .replace(/H/g, h)
    .replace(/MM/g, ('0' + min).slice(-2))
    .replace(/M/g, min)
    .replace(/SS/g, ('0' + s).slice(-2))
    .replace(/S/g, s)
}

export const dtFormat = (date, format) => {
  return _dtFormat(date, format, false)
}

export const dtFormatUTC = (date, format) => {
  return _dtFormat(date, format, true)
}

export const lineBreakToBR = (str) => {
  if (!str) { return '' }

  return str
    .replace(/\r\n|\\r\\n/g, '<br>')
    .replace(/\r|\\r/g, '<br>')
    .replace(/\n|\\n/g, '<br>')
}

export const splitByLineBreak = (str) => {
  if (!str) { return [] }
  return lineBreakToBR(str).split('<br>')
}
